import Flickity from "flickity";

const logoPartnersCarouselElement = document.querySelector('.logo-partners-carousel');

if (logoPartnersCarouselElement) {
    const logoPartnersCarousel = new Flickity(logoPartnersCarouselElement, {
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        contain: true,
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        imagesLoaded: true,
        wrapAround: true,
        draggable: false
    });

    logoPartnersCarousel.on('change', () => {
        logoPartnersCarousel.playPlayer();
    });
}
